export default __webpack_public_path__ + "files/media/SF-Ham-HD.9a131788.jpg";